<template>
  <b-card style="height: 266px" class="position-relative">
    <b-card-title>实时节能量</b-card-title>
    <b-button class="btn-icon rounded-circle" variant="flat-primary" style="position: absolute; top: 0.5rem; right: 0.5rem">
      <b-icon-three-dots-vertical />
    </b-button>
    <div id="project-detail-prediction1" style="height: calc(100% - 42px)"></div>
    <!-- <div class="position-absolute" style="bottom: 3.2rem; left: 5rem">
      今日预计最大负荷
      {{ predictionMax.egname ? '(' + predictionMax.egname.replace('预测', '') + ')' : '' }}
      <b-badge variant="light-danger" class="ml-1">{{ predictionMax.value || '0' }}</b-badge>
      <small> kW @ {{ predictionMax.time || '00:00' }}</small>
    </div> -->
  </b-card>
</template>

<!-- <script>
import { Area } from '@antv/g2plot';
import { computed, onMounted, reactive, toRefs, watch } from '@vue/composition-api';
import { $themeColors } from '@themeConfig';
import { routerParams } from '@/libs/utils/routerParams';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'Prediction1',
  components: {
    VuePerfectScrollbar,
  },
  props: ['project_prediction'],
  setup(props) {
    const event = reactive({
      project_id: computed(() => {
        return routerParams('project_id');
      }),
      projectPrediction: computed(() => {
        return props.project_prediction || [];
      }),
      predictionMax: { egname: '', value: 0, time: '' },
      energy_chart: null,
    });
    watch(
      () => event.projectPrediction,
      (data) => {
        if (data) {
          if (event.energy_chart) {
            const datas = [
              {
                time: '00:00',
                value: 0,
              },
              {
                time: '01:00',
                value: 0,
              },
              {
                time: '02:00',
                value: 0,
              },
              {
                time: '03:00',
                value: 0,
              },
              {
                time: '04:00',
                value: 0,
              },
              {
                time: '05:00',
                value: 0,
              },
              {
                time: '06:00',
                value: 0,
              },
              {
                time: '07:00',
                value: 5.5,
              },
              {
                time: '08:00',
                value: 5.6,
              },
              {
                time: '09:00',
                value: 3.5,
              },
              {
                time: '10:00',
                value: 5.6,
              },
              {
                time: '11:00',
                value: 5.4,
              },
              {
                time: '12:00',
                value: 4.3,
              },
              {
                time: '13:00',
                value: 9.8,
              },
              {
                time: '14:00',
                value: 6.8,
              },
              {
                time: '15:00',
                value: 7.2,
              },
              {
                time: '16:00',
                value: 4.5,
              },
              {
                time: '17:00',
                value: 5.5,
              },
              {
                time: '18:00',
                value: 4.2,
              },
              {
                time: '19:00',
                value: 0,
              },
              {
                time: '20:00',
                value: 0,
              },
              {
                time: '21:00',
                value: 0,
              },
              {
                time: '22:00',
                value: 0,
              },
              {
                time: '23:00',
                value: 0,
              },
            ];
            event.energy_chart.changeData(datas);
          }
        }
      }
    );
    const chartInit = () => {
      const area = new Area('project-detail-prediction1', {
        theme: {
          colors10: Object.values($themeColors),
        },
        legend: {
          itemName: {
            style: { fill: '#82868b' },
          },
          position: 'top',
        },
        data: [],
        xField: 'time',
        yField: 'value',
        isStack: false,
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          nice: true,
          grid: {
            line: {
              style: {
                stroke: '#82868b',
                lineWidth: 1,
                lineDash: [1, 6],
                strokeOpacity: 0.7,
              },
            },
          },
        },
        /* areaStyle: () => {
                    return {
                        fill: "l(270) 0:#ffffff 0.5:#7ec2f3 1:#1890ff",
                    };
                }, */
        smooth: true,
        meta: {
          value: {
            alias: '数值',
            formatter: (value) => {
              return Math.round(value * 100) / 100;
            },
          },
        },
      });
      area.render();
      event.energy_chart = area;
    };
    onMounted(() => {
      chartInit();
      console.log('projectPrediction', event.projectPrediction);
    });

    return {
      ...toRefs(event),
    };
  },
};
</script> -->
<script>
import { Area } from '@antv/g2plot';
import { computed, onMounted, reactive, toRefs, watch } from '@vue/composition-api';
import { $themeColors } from '@themeConfig';
import { routerParams } from '@/libs/utils/routerParams';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'Prediction1',
  components: {
    VuePerfectScrollbar,
  },
  props: ['project_prediction'],
  setup(props) {
    const event = reactive({
      project_id: computed(() => {
        return routerParams('project_id');
      }),
      projectPrediction: computed(() => {
        return props.project_prediction || [];
      }),
      predictionMax: { egname: '', value: 0, time: '' },
      energy_chart: null,
    });

    // 定时器引用
    let timer = null;

    // 生成基于当前时间的数据
    const generateDataBasedOnTime = (originalData) => {
      const now = new Date();
      const currentHour = now.getHours();

      // 基于原始数据创建新数组
      return originalData.map((item, index) => {
        const hour = parseInt(item.time.split(':')[0]);
        // 如果是当前时间之后的数据，则设为0
        if (hour > currentHour) {
          return {
            time: item.time,
            value: 0,
          };
        }
        // 否则保持原始值
        return { ...item };
      });
    };

    // 更新最大值
    const updateMaxValue = (data) => {
      let max = { egname: '', value: 0, time: '' };
      if (data) {
        data.forEach((item) => {
          if (item.value >= max.value) {
            max = {
              egname: '实时节能量',
              value: item.value,
              time: item.time,
            };
          }
        });
      }
      event.predictionMax = max;
    };

    // 更新图表数据
    const updateChartData = () => {
      if (event.energy_chart) {
        // 原始数据
        const originalDatas = [
          {
            time: '00:00',
            value: 0,
          },
          {
            time: '01:00',
            value: 0,
          },
          {
            time: '02:00',
            value: 0,
          },
          {
            time: '03:00',
            value: 0,
          },
          {
            time: '04:00',
            value: 0,
          },
          {
            time: '05:00',
            value: 0,
          },
          {
            time: '06:00',
            value: 0,
          },
          {
            time: '07:00',
            value: 7.5,
          },
          {
            time: '08:00',
            value: 7.6,
          },
          {
            time: '09:00',
            value: 5.5,
          },
          {
            time: '10:00',
            value: 7.6,
          },
          {
            time: '11:00',
            value: 7.4,
          },
          {
            time: '12:00',
            value: 6.3,
          },
          {
            time: '13:00',
            value: 11.8,
          },
          {
            time: '14:00',
            value: 8.8,
          },
          {
            time: '15:00',
            value: 9.2,
          },
          {
            time: '16:00',
            value: 6.5,
          },
          {
            time: '17:00',
            value: 7.5,
          },
          {
            time: '18:00',
            value: 6.2,
          },
          {
            time: '19:00',
            value: 0,
          },
          {
            time: '20:00',
            value: 0,
          },
          {
            time: '21:00',
            value: 0,
          },
          {
            time: '22:00',
            value: 0,
          },
          {
            time: '23:00',
            value: 0,
          },
        ];

        // 根据当前时间生成数据
        const datas = generateDataBasedOnTime(originalDatas);

        // 更新图表
        event.energy_chart.changeData(datas);

        // 更新最大值
        updateMaxValue(datas);
      }
    };

    // 精确安排下一次更新
    const scheduleNextUpdate = () => {
      const now = new Date();
      // 计算到下一个整点的时间
      const nextHour = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() + 1, 0, 0, 0);

      const delay = nextHour - now;

      // 清除之前的定时器
      if (timer) {
        clearTimeout(timer);
      }

      // 设置新的定时器
      timer = setTimeout(() => {
        updateChartData();
        scheduleNextUpdate(); // 递归调用以继续安排更新
      }, delay);
    };

    watch(
      () => event.projectPrediction,
      (data) => {
        if (data && event.energy_chart) {
          updateChartData();
        }
      }
    );

    const chartInit = () => {
      const area = new Area('project-detail-prediction1', {
        theme: {
          colors10: Object.values($themeColors),
        },
        legend: {
          itemName: {
            style: { fill: '#82868b' },
          },
          position: 'top',
        },
        data: [],
        xField: 'time',
        yField: 'value',
        isStack: false,
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          min: 0,
          max: 20,
          nice: true,
          grid: {
            line: {
              style: {
                stroke: '#82868b',
                lineWidth: 1,
                lineDash: [1, 20],
                strokeOpacity: 0.7,
              },
            },
          },
          label: {
            formatter: (value) => {
							return `${value}%`;
            },
          },
        },
        smooth: true,
        meta: {
          value: {
            alias: '数值',
            formatter: (value) => {
              return Math.round(value * 100) / 100;
            },
          },
        },
      });
      area.render();
      event.energy_chart = area;
    };

    onMounted(() => {
      chartInit();
      // updateChartData(); // 立即更新一次数据
      scheduleNextUpdate(); // 安排下一次整点更新
      console.log('projectPrediction', event.projectPrediction);
    });

    // 清理定时器
    const beforeDestroy = () => {
      if (timer) {
        clearTimeout(timer);
      }
    };

    return {
      ...toRefs(event),
      beforeDestroy,
    };
  },
};
</script>

<style scoped></style>
